import CryptoJS from 'crypto-js';
import axios from 'axios';

import { API_ROOT, SECRET_KEY } from '../settings';


export const getAuth = () => {
  const auth_local = localStorage.getItem('auth');
  if (auth_local) {
    const auth_crypto = CryptoJS.AES.decrypt(auth_local.toString(), SECRET_KEY);
    return JSON.parse(auth_crypto.toString(CryptoJS.enc.Utf8));
  } else {
    return auth_local;
  }
};

export const setAuth = (auth) => {
  const auth_crypto = CryptoJS.AES.encrypt(JSON.stringify(auth), SECRET_KEY);
  localStorage.setItem('auth', auth_crypto);
};

export const login = (auth = {}) => {
  setAuth(auth);
  return {
    type: 'LOGIN',
    ...auth
  }
};

export const logout = (response = null) => {
  if (response && response.data && response.data.detail) {
    switch (response.data.detail) {
      case 'Invalid token.':
        alert('You have been logged out from a more recent login with this account.');
        break;
      case 'Token has expired.':
        alert('You have been logged out after 48 hours of inactivity.');
        break;
      case 'User inactive or deleted.':
        alert('You have been logged out because your account no longer exists.');
        break;
    }
  }
  localStorage.removeItem('auth');
  return {
    type: 'LOGOUT'
  }
};

export const tempLogin = () => {
  const auth = getAuth();
  if (auth) {
    return login(auth);
  } else {
    return logout();
  }
};

export const validateAuth = (token = null) => {
  if (token === null) {
    const auth = getAuth();
    token = auth ? auth.token : null;
  }
  if (token) {
    return dispatch => {
      const endpoint = 'validateToken';
      axios({
        method: 'post',
        url: `${API_ROOT}/api/puma/${endpoint}/`,
        headers: { Authorization: `Token ${token}` }
      }).then(response => {
        dispatch(login(response.data.result));
      }).catch((e) => {
        const error = e.response ? e.response.data : e;
        if (e.response.status === 401) {
          dispatch(logout(e.response));
        } else {
          console.log(endpoint, error);
        }
      });
    };
  } else {
    return logout();
  }
};


// WEBPACK FOOTER //
// ./src/actions/authActions.jsx